/**
 * Ryan O'Dowd
 * 2024-02-07
 * © Copyright 2024 Oakwood Software Consulting, Inc. All Rights Reserved.
 */
import {
  Platform,
} from 'react-native';

const getStyles = ({fonts, globalScale, colors, safeAreaInsets}) => {
  return {
    helpIcon: {
      color: colors.white,
      margin: 0,
    },
    headerText: {
      fontFamily: fonts.secondaryBold,
      fontSize: globalScale * 24,
      lineHeight: globalScale * 24,
    },
    title: {
      fontSize: globalScale * 20,
      fontFamily: fonts.secondaryBold,
      color: colors.white,
    },
    subHeaderContainer: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'space-evenly',
      alignItems: 'center',
      backgroundColor: colors.accent,
      padding: 8,
      marginBottom: 4,
    },
    subHeaderText: {
      fontSize: globalScale * 14,
      fontFamily: fonts.secondary,
      color: colors.primaryExtraDark,
    },
    modulesWrapper: {
      paddingHorizontal: 4,
    },
    module: {
      gap: globalScale * 8,
    },
    moduleNameWrapper: {
      display: 'flex',
      flexGrow: 1,
      flexDirection: 'row',
      justifyContent: 'flex-start',
      alignItems: 'center',
      marginVertical: globalScale * 4,
    },
    nameAndAvailabliity: {
      display: 'flex',
    },
    moduleName: {
      fontFamily: fonts.secondaryBold,
      textAlign: 'left',
      fontSize: globalScale * 18,
      color: colors.lightText,
    },
    lockedRow: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'flex-start',
      alignItems: 'center',
      marginTop: globalScale * 2,
    },
    availablity: {
      color: colors.accent,
      fontSize: globalScale * 12,
      marginLeft: globalScale * 4,
    },
    moduleProgress: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'center',
      alignItems: 'center',
      alignSelf: 'flex-start',
      paddingRight: globalScale * 8,
    },
    disabled: {
      opacity: 0.5,
    },
    checkboxAndItemWrapper: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'flex-start',
      alignItems: 'center',
      gap: globalScale * 4,
    },
    iconAndNameWrapper: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'flex-start',
      alignItems: 'center',
    },
    assignmentOuterWrapper: {
      flex: 1,
    },
    assignmentTypeIcon: {
      marginRight: 6,
    },
    mainTitle: {
      display: 'flex',
      flexShrink: 1,
      fontFamily: fonts.secondaryBold,
      fontSize: globalScale * 18,
      color: colors.white,
    },
    subTitle: {
      display: 'flex',
      flexShrink: 1,
      // @TODO: fontFamily: fonts.secondaryBold,
      fontSize: globalScale * 14,
      color: colors.white,
    },
    rowTwo: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'space-between',
      alignItems: 'center',
      marginTop: 2,
    },
    innerContainer: {
      flex: 1,
    },
    topDataWrapper: {
      flex: 1,
      width: '100%',
      maxWidth: 600, // @TODO: make sure this is only on desktop
      alignSelf: 'center',
    },
    settingsSectionWrapper: { // @TODO: in the dialog...could probably be in commonStyles
      marginTop: 8,
      padding: 8,
      paddingTop: 0,
    },
    settingsSectionTitle: {
      fontSize: globalScale * 16,
      fontFamily: fonts.secondaryBold,
      color: colors.white,
    },
    reviewTitleWrapper: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'space-between',
      alignItems: 'center',
    },
    settingsText: {
      flex: 1,
      display: Platform.OS === 'web' ? 'inline' : 'flex',
      flexWrap: 'wrap',
      fontSize: globalScale * 14,
      color: colors.white,
    },
    settingsTextBold: {
      display: Platform.OS === 'web' ? 'inline' : 'flex',
      color: colors.accent,
      fontFamily: fonts.primaryBold,
    },
    hideSettingsWrapper: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'space-between',
      gap: 8,
      alignItems: 'center',
    },
    checkboxWrapper: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      margin: 0,
      marginLeft: 4,
    },
    selectionLegend: {
      flex: 1,
      flexDirection: 'row',
      justifyContent: 'space-around',
      gap: 8,
      flexWrap: 'wrap',
    },
    sliderAndTextWrapper: {
      flex: 1,
      flexDirection: 'column',
      width: '100%',
      alignItems: 'flex-start',
      paddingHorizontal: 8,
    },
    sliderContainer: {
      flex: 1,
      width: '100%',
    },
    thumbContainer: {
      flex: 1,
      justifyContent: 'center',
      alignItems: 'center',
      backgroundColor: colors.complete,
      padding: 4,
      marginTop: -3,
      marginLeft: -3,
      borderRadius: globalScale * 8, // @TODO: look okay?
    },
    thumbText: {
      fontSize: 14,
      color: colors.primaryExtraDark,
    },
    topRow: {
      flexDirection: 'row',
      justifyContent: 'space-between',
      alignItems: 'center',
      gap: 4,
    },
    groupGoalTopRow: { // to keep all checkboxes aligned with each other
      marginLeft: 6,
    },
    passageRow: {
      flexDirection: 'row',
      alignItems: 'center',
      marginBottom: 4,
    },
    errorText: {
      flex: 1,
      fontSize: globalScale * 14,
      color: colors.white,
      textAlign: 'left',
    },
    expandAllButton: {
      fontSize: globalScale * 22,
      color: colors.white,
    },
    hideButtonWrapper: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'flex-end',
      alignItems: 'center',
      margin: 8,
    },
    mainListContainer: {
      gap: 4,
      paddingBottom: safeAreaInsets.bottom,
    },
    minigameRow: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'space-between',
      alignItems: 'center',
    },
    minigameErrorText: {
      fontSize: globalScale * 16,
      color: colors.complete,
      alignSelf: 'center',
    },
  };
};

export default getStyles;
